import React, { CSSProperties, PropsWithChildren, useCallback, useRef } from 'react';
import classNames from 'classnames';
import './modal.scss';
import { CloseIcon } from '@icons/icons/CloseIcon';
import { IconButton } from '@components/buttons/IconButton/IconButton';
import { useTheme } from '@context/themeContext';

export interface ModalProps {
    title: string;
    setVisible: (close: boolean) => void;
    testId?: string;
    style?: CSSProperties;
    narrow?: boolean;
}

const Modal = ({
    title,
    setVisible,
    testId,
    children,
    style,
    narrow,
}: PropsWithChildren<ModalProps>) => {
    const ref = useRef<any>(null);
    const { theme } = useTheme();

    const className = classNames('modal', narrow && 'narrow');

    const handleCloseClick = e => {
        setVisible(false);
    };

    return (
        <div className={className} {...(testId ? { 'data-testid': testId } : {})}>
            <div className={`modal-wrapper ${theme}`} ref={ref} style={style}>
                <div className="modal-content">
                    <div className={`content-header ${theme}`}>
                        <span>{title}</span>
                        <IconButton icon={CloseIcon} onClick={handleCloseClick} />
                    </div>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Modal;
